import { PositioningPhase } from '@zeus/index'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { demoPath } from '~/pages/help/demo/demo-path'
import DemoBanner from '~/pages/help/demo/DemoBanner'
import PathDocumentsCard from '~/pages/scorm/components/documents/PathDocumentsCard'
import LearnerFrame from '~/pages/scorm/components/LearnerFrame'
import PositioningCard from '~/pages/scorm/components/positioning/PositioningCard'
import SessionPathView from '~/pages/scorm/SessionPathView'

/**
 * L'écran d'un parcours, en démonstration (#105) : la vraie vue, sur un parcours
 * fictif. Sa route n'a pas d'id, donc le centre d'aide sait la lancer, et rien
 * ne s'ouvre : lancer un module y dit seulement qu'on est dans une démo.
 */
function PathDemo() {
  const { t } = useTranslation()
  const session = demoPath(t)
  const inert = () => toast.info(t('helpDemo.inert'))

  return (
    <LearnerFrame label={session.name}>
      <DemoBanner backTo="/help" />
      <SessionPathView
        session={session}
        onLaunch={inert}
        onDownloadCertificate={inert}
        downloadingCertificate={false}
        // Des documents et le positionnement d'entrée (#326, #321), pour que la visite les montre.
        documents={(
          <PathDocumentsCard
            documents={[
              { id: 'demo-rules', title: t('helpDemo.path.documents.rules'), requiredBeforeStart: true, acknowledgedAt: null },
              { id: 'demo-booklet', title: t('helpDemo.path.documents.booklet'), requiredBeforeStart: false, acknowledgedAt: null },
            ]}
            formatDate={String}
            onDownload={inert}
            onAcknowledge={inert}
          />
        )}
        positioning={<PositioningCard phase={PositioningPhase.ENTRY} onOpen={inert} />}
      />
    </LearnerFrame>
  )
}

export default PathDemo
